import IndexPage from "./Pages/IndexPage";
import React from "react";
import {createRoutesFromElements, Route, RouterProvider} from "react-router";
import {createBrowserRouter} from "react-router-dom";
import Root from "./Pages/Root";
import NotFoundPage from "./Pages/NotFoundPage";
import WorkPage from "./Pages/WorkPage";
import SearchResultPage from "./Pages/SearchResultPage";
import AdvanceSearchPage from "./Pages/AdvanceSearchPage";
import './Styles/App.css';

const App = () => <RouterProvider router={router} />;

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Root />}>
                <Route path="/" element={<IndexPage />} />
                <Route path="index" element={<IndexPage />} />
                <Route path="works/:id" element={<WorkPage />} />
                <Route path="search/:query" element={<SearchResultPage />} />
                <Route path="advanced-search/" element={<AdvanceSearchPage />} />

                <Route path="*" element={<NotFoundPage />} />
        </Route>
    )
);

export default App;
